import { fetch as fetchPolyfill } from 'whatwg-fetch';
import { DateTime, Settings } from 'luxon';
import { intersection } from 'lodash';

import { getEvents } from '../utils/api';
import { getCookie } from '../utils/cookie-handler';

Settings.defaultZoneName = 'America/Chicago';

const cookies = {
    logged_in: '_bo_logged_in',
    customer_no: 'customer_no',
    favorites: 'favorites',
};

const endpoints = {
    add: 'api/favorites/add',
    remove: 'api/favorites/remove',
};

const now = DateTime.now();

export function isLoggedIn() {
    return parseInt(getCookie(cookies.logged_in), 10) === 1;
}

export function customerNo() {
    return parseInt(getCookie(cookies.customer_no), 10);
}

export function getFavoritesFromCookie() {
    let favorites;

    try {
        favorites = JSON.parse(getCookie(cookies.favorites));
    } catch (e) {
        favorites = {
            cNo: 'null',
            pNos: [],
        };
    }

    return favorites;
}

export function getUserFavorites() {
    let performances = [];
    let favorites = getFavoritesFromCookie();

    if (isLoggedIn() && parseInt(favorites.cNo, 10) === customerNo()) {
        performances = favorites.pNos;
    } else if (isLoggedIn() === false && String(favorites.cNo) === 'null') {
        performances = favorites.pNos;
    }

    return getEvents().then(events => {
        events = events.filter(event => {
            return DateTime.fromISO(event.perf_date) > now;
        });

        events = events.map(event => {
            return parseInt(event.perf_no, 10);
        });

        return intersection(events, performances);
    });
}

export function getUserFavoritesCount() {
    return getUserFavorites().then(favorites => {
        return favorites.length;
    });
}

export function isFavorite(perfNo) {
    return getUserFavorites().then(favorites => {
        return favorites.some(item => {
            return parseInt(item, 10) === parseInt(perfNo, 10);
        });
    });
}

export function persistFavorite(perfNo, doAdd) {
    const endpoint = doAdd ? endpoints.add : endpoints.remove;

    const url = `${window.AppConfig.bo_url}/${endpoint}/${perfNo}`;

    const request = {
        method: 'POST',
        credentials: 'include',
    };

    return fetchPolyfill(url, request).finally(() => {
        window.dispatchEvent(new Event('favorites'));
    });
}

export default {
    getFavoritesFromCookie,
    getUserFavorites,
    getUserFavoritesCount,
    isFavorite,
    persistFavorite,
};
